import React from 'react'
import './containers.css'

const CardContainer: React.FunctionComponent<any> = ({ children }) => {
  return (
    <div className='card-container'>
      { children }
    </div>
  )
}

export default CardContainer